import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { updateNetworkAvailability } from "../../../actions/sensors";
import isElectron from "is-electron";


const NetworkSensor = ( props ) => {

    useEffect ( () => {
        if ( window.navigator.onLine ) {
            setOnline ();
        } else {
            setOffline ();
        }
        window.addEventListener ( 'online', setOnline );
        window.addEventListener ( 'offline', setOffline );
        return () => {
            window.removeEventListener ( 'online', setOnline );
            window.removeEventListener ( 'offline', setOffline );
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    const setOnline = () => {
        if ( isElectron () ) {
            console.info ( "we're online" )
            props.updateNetworkAvailability ( true )
        }
    }

    const setOffline = () => {
        if ( isElectron () ) {
            console.info ( "network is offline" )
            props.updateNetworkAvailability ( false );
        }
    }

    return null;
}

const mapStateToProps = ( state ) => ( {
    isNetworkAvailable: state.sensors.isNetworkAvailable
} )
const mapDispatchToProps = ( dispatch ) => {
    return bindActionCreators ( {
        updateNetworkAvailability: updateNetworkAvailability,
    }, dispatch );
};

export default connect (
    mapStateToProps, mapDispatchToProps
) ( NetworkSensor );
